import { render, staticRenderFns } from "./FullNameCell.vue?vue&type=template&id=493967ab&"
import script from "./FullNameCell.vue?vue&type=script&lang=js&"
export * from "./FullNameCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports